/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.gestionauditorias': 'Gestión auditorías',
  'gestionauditorias.NumeroDocumento': 'N° Documento',
  'gestionauditorias.FechaCreacion': 'Fecha creación',
  'gestionauditorias.BodegaOrigenDescripcion': 'Bodega origen',
  'gestionauditorias.BodegaDestinoDescripcion': 'Bodega destino',
  'gestionauditorias.DocumentoRelacionado': 'Documento relacionado',
  'gestionauditorias.EstadoDocumento': 'Estado documento',
  'gestionauditorias.Bodegas': 'Bodegas',
  'gestionauditorias.FechaInicial': 'Fecha inicial',
  'gestionauditorias.FechaFinal': 'Fecha final',
  'gestionauditorias.BodegaId': 'Bodega',
  'gestionauditorias.observaciones': 'Observaciones',
  'gestionauditorias.DivisionId': 'División',
  'gestionauditorias.ConteoUnico': 'Conteo único',
  'gestionauditorias.GenerarSaldoActual': 'Generar saldo actual',
  'gestionauditorias.PersonaCreacion': 'Persona asociada',
  'gestionauditorias.modificarEtapa': 'Cambiar etapa',
  'gestionauditorias.datosDocumento': 'Datos documento',
  'gestionauditorias.detallesDelDocumento': 'Detalles del documento',
  'gestionauditorias.busquedaDetalles': 'Búsqueda detalles',
  'gestionauditorias.etapaDescripcion': 'Etapa',
  'gestionauditorias.Detalles.CodigoBarras': 'Código barras',
  'gestionauditorias.Detalles.DescripcionItem': 'Descripción ítem',
  'gestionauditorias.Detalles.CantidadRecibida': 'Cantidad conteo 1',
  'gestionauditorias.Detalles.CantidadEntregada': 'Cantidad conteo 2',
  'gestionauditorias.Detalles.CantidadActual': 'Cantidad en inventario',
  'gestionauditorias.Detalles.DescripcionDivisionOrigen': 'División',
  'gestionauditorias.Detalles.DescripcionDivisionDestino': 'División destino',
  'gestionauditorias.Detalles.Serial': 'Serial',
  'gestionauditorias.Detalles.Lote': 'Lote',
  'gestionauditorias.Detalles.FechaVencimiento': 'Fecha vencimiento',
  'gestionauditorias.Detalles.crearDetalleDocumento': 'Crear detalle documento',
  'gestionauditorias.Detalles.editarDetalleDocumento': 'Editar detalle documento',
  'gestionauditorias.Detalles.Division': 'División',
  'gestionauditorias.boton.administrarConteos': 'Modificar estado conteo',
  'gestionauditorias.boton.generarDiferencias': 'Generar diferencias',
  'gestionauditorias.titulo.productoSinContar': 'Productos sin contar',
  'gestionauditorias.titulo.editarDetallesAuditoria': 'Editar detalles auditoría',
  'gestionauditorias.titulo.crearAuditoria': 'Crear auditoría',
  'gestionauditorias.titulo.editarAuditoria': 'Editar auditoría',
  'gestionauditorias.alerta.fechasInicialInvalida': 'La fecha inicial debe ser menor a la fecha final',
  'gestionauditorias.alerta.fechaIncompleta': 'Ingrese las dos fechas para poder realizar la búsqueda',
  'gestionauditorias.alerta.primerConteo': '¿Está seguro que desea iniciar el primer conteo?',
  'gestionauditorias.alerta.segundoConteo': '¿Está seguro que desea iniciar el segundo conteo?',
  'gestionauditorias.alerta.finalizarConteo': '¿Está seguro que desea finalizar el conteo?',
  'gestionauditorias.alerta.iniciarAuditoria':
    'No es posible agregar o modificar el detalle de la auditoria si no ha sido iniciada, por favor verifique.',
  'gestionauditorias.alerta.anular': '¿Está seguro que desea anular el documento?',
  'gestionauditorias.FamiliaId': 'Familia',
  'gestionauditorias.ItemId': 'Producto',
};
